module.exports = __webpack_public_path__ + "static/media/BS_F_Embroidery_Bicocca_Bordeaux_White.46195083.png";